
import { useEffect, useRef, useState } from "react";
import { useScript } from "react-apple-signin-auth";
import { Modal } from "react-bootstrap";
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useGoogleLogin } from "@react-oauth/google";
import { subscribeUser } from "@/api/favorites";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsUserSubscribed, setLoginCallLocation, setLoginModal, setLoginTab, setPropertyToSaveFrom, setSubscribeEmailAlreadyExists } from "@/redux/login/loginSlice";
import { setCookie } from "@/utils/cookies";
import { setIsAddedToSaved, showSavedTooltip } from "@/redux/savedpreference/savedPreferenceSlice";
import { onSavePress, onUnsavePress } from "@/api/srpFilter";
import { setSelectedProperty, updateFavorite } from "@/redux/SRP/srpSlice";
import { getEventCategory, trackApiCall, trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { encrypt } from "@/utils/crypto";
import { googleSignin, handleSocialAuth } from "@/api/LoginSignup";
import FavHeartSvg from "../../../public/assets/svg/property-card/FavHeartSvg";

function FavoriteModal({ showModal, handleClose, item, isMapCard, setShowModal}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const isValidating = useRef(false);

  const { srpTupples } = useSelector((state) => state.srp.srpInitData);
  const { selectedProperty } = useSelector((state) => state.srp);
  const { propertyToSaveFrom, isUserSubscribed } = useSelector((state) => state.login);
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);

  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [emailError, setEmailError] = useState();

  useEffect(() => {
    if (propertyToSaveFrom !== 'PDP' && item?.propertyId === propertyToSaveFrom && (userEmailId || isUserSubscribed)) {
      onSave(propertyToSaveFrom);
    }
  }, [propertyToSaveFrom, isUserSubscribed, userEmailId]);
  useEffect(() => {
    if (!showModal) {
      setEmailError('');
    }
  }, [showModal]);

  const validateEmail = async () => {
    if (isValidating.current) return;
    isValidating.current = true;

    var isValidEmail = true;
    if (!email) {
      setEmailError("Please enter vaild email")
      isValidEmail = false;
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      isValidEmail = false
      setEmailError("Please enter vaild email")
    };
    if (isValidEmail) {
      setEmailError("")
    }
    if (isValidEmail) {
      trackButtonClick({
        eventName: "quick_registration_click",
        eventCategory: getEventCategory(),
        eventLabel: "referrer: QuickRegister",
      });

      const data = await subscribeUser(email);
      if (data?.data === "EMAIL_ALREADY_EXIST") {
        loginNavigation();
        dispatch(setSubscribeEmailAlreadyExists(true));
        setCookie("userEmail", email, 30);
        setCookie("loggedInEmail", email, 30);
        dispatch(setIsUserSubscribed(false));
      } else {
        handleClose();
        setCookie("userEmail", email, 30);
        setCookie("subscribedUser", true, 30);
        setCookie("loggedInEmail", email, 30);
        setCookie("subscribeEmail", window.btoa(email), 30);
        dispatch(setIsUserSubscribed(true));
        dispatch(setSubscribeEmailAlreadyExists(false));
        // dispatch(setPropertyToSaveFrom(null))
        item?.propertyId && dispatch(setPropertyToSaveFrom(item?.propertyId));
        // onSave();

        // Persist the analytics user id in a cookie ONLY (not Redux) so it never
        // leaks into API payloads that read state.user.user.realbidUserId.
        // Analytics picks it up via getUserContext()'s `gaUserId` fallback, so
        // user_uid is attached to all events during the registration window.
        if (data?.data?.realBidUserId) {
          setCookie("gaUserId", data.data.realBidUserId, 30);
        }

        trackApiCall({
          eventName: "register_completed",
          eventCategory: getEventCategory(),
          eventSource: "on quick register completed",
          user_uid: data?.data?.realBidUserId || "",
        });

        trackButtonClick({
          eventName: "quick_register",
          eventCategory: getEventCategory(),
          eventSource: "referrer: QuickRegister",
          user_uid: data?.data?.realBidUserId || "",
        });
      }
    }

    setTimeout(() => {
      isValidating.current = false;
    }, 300);

    return isValidEmail
  }

  const handleAppleLogin = async () => {
    try {
      // setIsLoading(true);
      setError("");
    let uri = "";
    const host = window.location.host;
    if (host === "preview.hubzu.com") {
      uri = window.location.origin + "/";
    } else if (host === "hubzu.com" || host === "www.hubzu.com") {
      uri =window.location.origin + "/";
    } else if (host === "trunkhubzu-integ.internal.hubzu.com") {
      uri = window.location.origin;
    } else if(host === "mirror.hubzu.com" ||  host === "www.mirror.hubzu.com"){
         uri = window.location.origin + "/";
      }
     else {
      uri = "https://buy-bid-participation-feature-web-ui.internal.hubzu.com";
    }

      // Check if AppleID is available
      if (!window.AppleID) {
        throw new Error("Apple Sign In is not initialized");
      }

      // Initialize Apple SignIn with correct configuration
      await window.AppleID.auth.init({
        clientId: "com.hubzu.internal", // Your Apple Service ID
        scope: "name email",
        redirectURI: uri, // Use your domain
        state: "origin:web",
        usePopup: true,
        nonce: generateNonce(), // Generate a random nonce
        response_mode: "form_post",
        response_type: "code id_token",
      });

      // Perform Apple Sign In
      const appleResponse = await window.AppleID.auth.signIn();
      console.log("Apple Sign In Response:", appleResponse);

      if (!appleResponse?.authorization?.id_token) {
        trackApiCall({
          eventName: "quick_sign_in_failure",
          eventSource: "Apple signin failure",
          eventCategory: "Sign-In - invalid token id",
        });
        throw new Error("No authentication token received from Apple");
      }

      // Create payload for your API
      const appleUser = {
        encAlgVersion: "V4",
        token: appleResponse.authorization.id_token,
        jwtToken: appleResponse.authorization.id_token,
        // Include additional data if needed
        user: appleResponse.user || {},
        code: appleResponse.authorization.code,
      };

      // Call social auth API
      const response = await handleSocialAuth(appleUser, "apple");

      if (response?.status === "SUCCESS") {
        // Extract user data
        const { firstName, lastName, email } = response.data;

        // Store user info
        if (firstName) localStorage.setItem("userFirstName", firstName);
        if (lastName) localStorage.setItem("userLastName", lastName);
        if (email) setLoginCookie(email);


        trackApiCall({
          eventName: "quick_sign_in_success",
          eventSource: "Apple signin success",
          eventCategory: "Sign-In",
        });

        onSave()
        toast.success("Successfully logged in with Apple!");
        navigate("/dashboard");
      } else {
        trackApiCall({
          eventName: "quick_sign_in_failure_error",
          eventSource: "Apple signin failure",
          eventCategory: "Sign-In - authentication failed",
        });
        throw new Error(response.message || "Authentication failed");
      }
    } catch (error) {
      console.error("Apple login error:", error);

      trackApiCall({
        eventName: "quick_sign_in_failure",
        eventSource: "Apple signin failure",
        eventCategory: `Sign-In - ${error?.message}`,
      })

      // Handle specific Apple Sign In errors
      let errorMessage = "Failed to login with Apple";

      if (error.error === "popup_closed_by_user") {
        errorMessage = "Apple sign in was cancelled";
      } else if (error.error === "invalid_client") {
        errorMessage = "Invalid client configuration";
      } else if (error.error === "invalid_scope") {
        errorMessage = "Invalid scope requested";
      } else if (error.error === "unauthorized") {
        errorMessage = "Unauthorized access";
      } else if (error.message?.includes("not initialized")) {
        errorMessage = "Apple Sign In is not properly configured";
      } else if (
        error.message?.includes("No authentication token received from Apple")
      ) {
        errorMessage = "No authentication token received from Apple";
      } else if (
        error.message?.includes("No authentication token received from Apple")
      ) {
        errorMessage = "No authentication token received from Apple";
      } else if (error.message?.includes("Authentication failed")) {
        errorMessage = "Authentication failed";
      } else {
        errorMessage =
          error.message || "Unknown error occurred during Apple Sign In";
      }
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      // setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
  }

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        setError("");

        // Get user info using access token
        const userInfoResponse = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );

        const userInfo = await userInfoResponse.json();
        const googleUser = {
          encAlgVersion: "V3",
          emailId: await encrypt(userInfo.email),
          firstName: userInfo.given_name,
          lastName: userInfo.family_name,
          emailVerified: userInfo.email_verified.toString(),
        };
        console.log("google user", googleUser);

        // Call with 'google' service
        const response = await googleSignin(googleUser);

        if (response?.status === "SUCCESS") {
          setIsSocialSignin(true);
          // Handle success
          localStorage.setItem("userFirstName", userInfo.given_name);
          localStorage.setItem("userLastName", userInfo.family_name);

          trackApiCall({
            eventName: "quick_sign_in_success",
            eventSource: "Google signin success",
            eventCategory: "Sign-In",
          });

          onSave()
          setLoginCookie(userInfo.email);
          toast.success("Successfully logged in with Google!");
          if (!isPhoneNumberVerification) {
            navigate("/");
          }
        } else {
          trackApiCall({
            eventName: "quick_sign_in_failure_error",
            eventSource: "Google signin failure",
            eventCategory: "Sign-In - authentication failed",
          });
          throw new Error(response.message || "Authentication failed");
        }
      } catch (error) {
        console.error("Google login error:", error);

        trackApiCall({
          eventName: "quick_sign_in_failure_error",
          eventSource: "Google signin failure",
          eventCategory: `Sign-In - ${error?.message}`,
        });

        setError(error.message || "Failed to login with Google");
        toast.error("Google login failed");
      } finally {
      }
    },
  });

  const handleGoogleLogin = (e) => {
    e.preventDefault();

    trackButtonClick({
      eventName: "quick_register_google_click",
      eventSource: "Signin with google click",
      eventCategory: getEventCategory(),
    });
    trackButtonClick({
      eventName: "quick_register_social_login",
      eventParams: {
        visitor_id: Cookies.get("visitorId"),
        social_login: "google",
      },
      eventSource: "Signin with google click",
      eventCategory: getEventCategory(),
    });

    setError("");
    googleLogin();
  };

  const handleAppleClick = (e) => {
    e.preventDefault();

    trackButtonClick({
      eventName: "quick_register_apple_click",
      eventSource: "Signin with google click",
      eventCategory: getEventCategory(),
    });
    trackButtonClick({
      eventName: "quick_register_social_login",
      eventParams: {
        visitor_id: Cookies.get("visitorId"),
        social_login: "apple",
      },
      eventSource: "Signin with google click",
      eventCategory: getEventCategory(),
    });

    setError("");
    handleAppleLogin();
    // <AppleSignin />
  };

  const onSave = async (propertyToSaveFrom) => {
    const eventCategory = getEventCategory();
    const propertyId = item?.propertyId || propertyToSaveFrom;
    // Get client ID from Google Analytics cookie
    const gaCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("_ga="));
    const clientId = gaCookie ? gaCookie.split("=")[1] : "";

    // Build eventLabel: full details on SRP, minimal on recommended cards.
    const favLabel = (srpDetails) =>
      eventCategory === "NEW-SRP" ? srpDetails : `Property id: ${propertyId}`;

    if (item?.onWatchList === "Y") {
      const updatedSrpTupples =
        srpTupples.length > 0 &&
        srpTupples.map((tupple) =>
          tupple.propertyId === propertyId
            ? { ...tupple, onWatchList: "" }
            : tupple
        );
      dispatch(updateFavorite(updatedSrpTupples));
      if (selectedProperty?.propertyId === propertyId) {
        dispatch(setSelectedProperty({ ...item, onWatchList: "" }));
      }
      const response = await onUnsavePress({ propertyId: propertyId });
      if (response === "success") {
        trackApiCall({
          eventName: `favourite_property_unsaved`,
          eventCategory: eventCategory,
          eventSource:
            eventCategory === "NEW-SRP"
              ? `srp_quick_register_modal`
              : `home_page_recommended`,
          eventLabel: favLabel(
            `Id: ${propertyId}| Location: ${getSrpLocationLabel()}`
          ),
        });
      } else {
        trackApiCall({
          eventName: `favourite_property_unsave_error`,
          eventCategory: "Error",
          eventSource: `Error - ${response?.message || "Data Initialization Failed"
            }`,
          eventLabel: `Property Id: ${propertyId}`,
        });
      }
      dispatch(setIsAddedToSaved());
    } else if (propertyId) {
      trackButtonClick({
        pageName: "favourite_property_save_click",
        eventCategory: getEventCategory(),
        eventSource: "srp_quick_register_modal",
        eventLabel: `Property Id: ${propertyId}`,
      });
      const updatedSrpTupples =
        srpTupples?.length > 0 &&
        srpTupples.map((tupple) =>
          tupple.propertyId === propertyId
            ? { ...tupple, onWatchList: "Y" }
            : tupple
        );
      dispatch(updateFavorite(updatedSrpTupples));
      if (selectedProperty?.propertyId === propertyId) {
        dispatch(setSelectedProperty({ ...item, onWatchList: "Y" }));
      }
      const response = await onSavePress({ propertyId: propertyId });
      if (response === "success") {
        trackApiCall({
          eventName: `favourite_property_saved`,
          eventCategory: eventCategory,
          eventSource:
            eventCategory === "NEW-SRP"
              ? `srp_quick_register_modal`
              : `home_page_recommended`,
          eventLabel: favLabel(
            `Id: ${propertyId}| Location: ${getSrpLocationLabel()}`
          ),
        });
      } else {
        trackApiCall({
          eventName: `favourite_property_save_error`,
          eventCategory: "Error",
          eventSource: `Error - ${response?.message || "Data Initialization Failed"
            }`,
          eventLabel: `Property Id: ${propertyId}`,
        });
      }

      dispatch(showSavedTooltip(true));
      dispatch(setIsAddedToSaved());
    }
    dispatch(setPropertyToSaveFrom(null));
  };

  const loginNavigation = () => {
    setShowModal(false);

    const eventCategory = getEventCategory();
    // Get client ID from Google Analytics cookie
    const gaCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("_ga="));
    const clientId = gaCookie ? gaCookie.split("=")[1] : "";

    trackButtonClick({
      eventName: "quick_register_sign_in_click",
      eventCategory: eventCategory,
      eventSource: `Quick register signin`,
      eventLabel: `Location: ${getSrpLocationLabel()}`,
    });

    if (pathname === "/") {
      navigate("/register-sign-in");
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("login"));
      item?.propertyId && dispatch(setPropertyToSaveFrom(item?.propertyId));
    } else {
      dispatch(setLoginModal(true));
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("Popup"));
      item?.propertyId && dispatch(setPropertyToSaveFrom(item?.propertyId));
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <div className="d-flex justify-content-between gap-2">
            <div><FavHeartSvg /></div>
            <div className="saveHead">Save this listing</div>
        </div>
      </Modal.Header>
      <Modal.Body>

        <div className="spss saveListing p20 pt0 pb0">
          <Row xs={12} md={12} className="d-flex align-items-start">
            <p className="save-popup-heading">Enter your e-mail to save this property to your favorites and to keep track of price and status changes.</p>

            <Col xs={8} md={8} className="d-flex align-items-start">
              <Row >
                <div className="d-flex p0">
                  <input type="email"
                    className="form-control hubzu-text-box myinput mb20"
                    id="exampleDropdownFormEmail1"
                    aria-label="email"
                    onChange={handleChange}
                    onFocus={() => {
                      const label = document.getElementById("myplaceholder");
                      if (label) label.style.display = 'none';
                    }}
                    onBlur={() => {
                      // validateEmail()
                      const label = document.getElementById("myplaceholder");
                      if (label) label.style.display = 'block';
                    }}
                    required
                  />
                  {!email && <div
                    id="myplaceholder"
                    className="myplaceholder"
                    onClick={(e) => {
                      const textInput = document.getElementById("exampleDropdownFormEmail1");
                      textInput.focus()
                    }}
                  >
                    Email Address <span className="asterisk">*</span>
                  </div>}
                </div>
                {emailError?.length > 0 &&
                  <span className="error-message">
                    {emailError}
                  </span>
                }
                <div className="haveAnyAccount p0">
                  Already have an account?{" "}
                  <a className="saveLoginText" onClick={loginNavigation}>
                    Sign In
                  </a>
                </div>
              </Row>
            </Col>
            <Col xs={4} md={4} className="smallFont d-flex align-items-start p0">
              <button
                className='saveRegisterBtn ml20'
                onClick={() =>
                  validateEmail()
                }>
                Register
              </button>
            </Col>

            {/* <div className="row mt25 socialLogins">
                        <div className="col-lg-12">
                          <div className="col-lg-12">
                            <p className="welcome-para">
                              Or, sign in with your Google account:
                            </p>
                            <button
                              type="button" // Changed from "submit" to "button"
                              className="btn btn-googl w-100"
                              onClick={handleGoogleLogin}
                            >
                              <img
                                src="/assets/images/googleIcon.png"
                                alt="Google Icon"
                                height={20}
                                width={20}
                                className="mx-3"
                              />
                              Continue with Google
                            </button>
                            <p className="welcome-para">
                              Or, sign in with your Apple account:
                            </p>
                            <div className="col-lg-12">
                              <button
                                type="submit"
                                className="btn btn-fb w-100"
                                onClick={handleAppleClick}
                              >
                                <i className="fa fa-apple fs-24"></i> Continue
                                with apple
                              </button>
                            </div>
                          </div>

                        </div>
                      </div> */}
          </Row>
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default FavoriteModal;
